import { Icon } from '@virtidev/toolbox';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCurrentHint,
  shownHintObjectiveIdsSelector,
  hitObjectiveIdsSelector,
  currentHintSelector,
  markShownObjectiveHint,
} from '../../../../slices/ObjectivesSlice';
import { easyModeSelector } from '../../../../slices/VirtualHumanSlice';
import { useShouldShowHints } from '../../../vh-types/vhTypeHooks';
import * as Styled from './Objective.styled';

const Objective = ({ objective }) => {
  const shownHintObjectiveIds = useSelector(shownHintObjectiveIdsSelector);
  const hitObjectiveIds = useSelector(hitObjectiveIdsSelector);
  const currentHint = useSelector(currentHintSelector);
  const hasShownHint = useMemo(
    () => shownHintObjectiveIds.includes(objective.id),
    [objective.id, shownHintObjectiveIds]
  );
  const wasHit = useMemo(
    () => hitObjectiveIds.includes(objective.id),
    [hitObjectiveIds, objective?.id]
  );
  const easyMode = useSelector(easyModeSelector);
  const dispatch = useDispatch();
  const shouldShowHints = useShouldShowHints();
  const clickableToShowHint = (hasShownHint && !wasHit) || easyMode;
  const handleClick = useCallback(() => {
    if (clickableToShowHint) {
      if (!hasShownHint) {
        dispatch(markShownObjectiveHint(objective.id));
      }
      dispatch(
        setCurrentHint({ objectiveId: objective.id, text: objective.hint })
      );
    }
  }, [
    dispatch,
    objective?.hint,
    objective.id,
    clickableToShowHint,
    hasShownHint,
  ]);
  const hintActive = currentHint && currentHint.objectiveId === objective.id;

  return (
    <Styled.ObjectiveWrapper>
      <Styled.Objective
        onClick={handleClick}
        wasHit={wasHit}
        clickableToShowHint={clickableToShowHint}
        hasShownHint={hasShownHint}
        hintActive={hintActive}
        disabled={!shouldShowHints}
        easyMode={easyMode}
      >
        {wasHit && <Icon icon="checkbox" size="1.2rem" />}
        {hasShownHint || wasHit || easyMode ? (
          <Styled.ObjectiveContent wasHit={wasHit}>
            {(hasShownHint || easyMode) && (
              <Styled.ObjectiveHintedIconWrapper
                title={
                  easyMode
                    ? ''
                    : "This objective's hint was revealed (it will not contribute to your session's score)."
                }
              >
                {!easyMode && <Icon size="1.2rem" icon="hint" />}
              </Styled.ObjectiveHintedIconWrapper>
            )}
            <Styled.ObjectiveName wasHit={wasHit}>
              {objective.name}
            </Styled.ObjectiveName>
          </Styled.ObjectiveContent>
        ) : (
          <Styled.ObjectiveUnknownIcon icon="help" />
        )}
      </Styled.Objective>
    </Styled.ObjectiveWrapper>
  );
};

export default Objective;
